// rxjs-extension/reactives/map.ts
import { BehaviorSubject } from "rxjs";
var MapBehaviorSubject = class extends BehaviorSubject {
  constructor(defaultMap = /* @__PURE__ */ new Map()) {
    super(defaultMap);
  }
  get(key) {
    return this.getValue().get(key);
  }
  set(key, value) {
    const result = this.getValue().set(key, value);
    this.next(this.getValue());
    return result;
  }
  clear() {
    return this.getValue().clear();
  }
  delete(key) {
    const result = this.getValue().delete(key);
    this.next(this.getValue());
    return result;
  }
  entries() {
    return this.getValue().entries();
  }
  keys() {
    return this.getValue().keys();
  }
  values() {
    return this.getValue().values();
  }
  has(key) {
    return this.getValue().has(key);
  }
};
export {
  MapBehaviorSubject as default
};
